import { styled } from "goober";

export const PanelShell = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const PanelCard = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 24px;
  overflow: auto;
  box-shadow: var(--elevation-low);
  background: var(--surface-primary);
  border-radius: 16px;
  outline: 0.5px solid var(--border-alpha);
`;

export const PanelHeader = styled("div")`
  width: 100%;
  max-width: 648px;
  padding-left: 24px;
  margin-bottom: 32px;
`;

export const PanelContentBox = styled("div")`
  width: 100%;
  max-width: 648px;
  padding: 24px;
  background: var(--surface-secondary);
  border-radius: 12px;
  border: 0.5px solid var(--border-alpha);

  & + & {
    margin-top: 24px;
  }
`;
